module.exports = __webpack_public_path__ + "img/ff03d_alt.db2ebf46.svg";